import { CalendarDays, ChevronDown, ChevronUp } from 'lucide-react';
import { useState } from 'react';

/** Par label/valor padrão das seções de detalhe da apólice (layout desktop). */
export function InfoRow({
  label,
  value,
}: {
  label: string;
  value?: string | null;
}) {
  return (
    <div className='flex flex-col gap-1 min-w-0'>
      <span className='text-sm font-bold text-alba-black-500'>{label}</span>
      <span className='text-sm text-alba-gray-600 break-words'>{value || '-'}</span>
    </div>
  );
}

/** Campo label/valor para o layout mobile, com divisória e ícone opcionais. */
export function MobileLabeledField({
  label,
  value,
  showCalendar = false,
  withDivider = true,
}: {
  label: string;
  value?: string | null;
  showCalendar?: boolean;
  withDivider?: boolean;
}) {
  return (
    <div className='flex flex-col gap-1 min-w-0'>
      <span className='text-sm font-bold text-alba-black-500'>{label}</span>
      {showCalendar ? (
        <div className='flex items-center gap-1 text-sm text-alba-gray-600'>
          <CalendarDays className='h-4 w-4 text-alba-gray-500' />
          <span className='break-words'>{value || '-'}</span>
        </div>
      ) : (
        <span className='text-sm text-alba-gray-600 break-words'>{value || '-'}</span>
      )}
      {withDivider && <div className='mt-1 h-px w-full bg-alba-gray-200' />}
    </div>
  );
}

/** Card colapsável usado como casca das seções da página de detalhe da apólice. */
export function AccordionSection({
  title,
  children,
  defaultOpen = true,
}: {
  title: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
}) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className='rounded-2xl border border-alba-gray-200/80 bg-white shadow-[0px_4px_24px_0px_rgba(15,22,30,0.08)]'>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className='flex w-full items-center justify-between rounded-t-2xl border-none bg-transparent px-5 py-4 text-left cursor-pointer sm:px-8 sm:py-0'
        style={{ minHeight: '72px' }}
      >
        <span className='text-base font-semibold leading-6 text-alba-black-500 sm:text-sm sm:font-medium sm:text-alba-gray-700'>
          {title}
        </span>
        {isOpen ? (
          <ChevronUp className='h-4 w-4 text-alba-gray-700' />
        ) : (
          <ChevronDown className='h-4 w-4 text-alba-gray-700' />
        )}
      </button>
      {isOpen && <div className='px-5 pb-5 sm:px-8 sm:pb-6'>{children}</div>}
    </div>
  );
}

/** Traduz o código de `typeOfInsurance` (Novo/Renovação) para exibição. */
export function getInsuranceTypeLabel(code?: string): string {
  const map: Record<string, string> = {
    '1': 'Novo',
    '2': 'Renovação',
    '3': 'Renovação Congênere',
  };
  return map[String(code ?? '').trim()] ?? '-';
}
